import { io } from "socket.io-client";
import { url } from "./url";

/**
 * اتصال WebSocket به بک‌اند (Socket.IO) — نسخه راننده
 *
 * طبق مستندات بک‌اند:
 * - اتصال با auth: { token: `Bearer ${token}`, role: "driver" }
 * - راننده تأییدشده به‌صورت خودکار عضو room نوع خودروی خودش می‌شود
 *   و event های travel:available / travel:unavailable را می‌گیرد.
 * - عضویت در Room سفر: socket.emit("travel:join", { travel_id })
 *
 * این ماژول یک اتصال singleton نگه می‌دارد تا در کل اپ فقط یک socket باز باشد.
 */

// نام رویدادها — دقیقاً مطابق EVENTS بک‌اند
export const SOCKET_EVENTS = {
  CONNECTED: "socket:connected",
  TRAVEL_JOIN: "travel:join",
  TRAVEL_LEAVE: "travel:leave",
  TRAVEL_AVAILABLE: "travel:available",
  TRAVEL_UNAVAILABLE: "travel:unavailable",
  TRAVEL_UPDATED: "travel:updated",
  TRAVEL_ACCEPTED: "travel:accepted",
  TRAVEL_DRIVER_RELEASED: "travel:driver_released",
  TRAVEL_CANCELED: "travel:canceled",
  TRAVEL_COMPLETED: "travel:completed",
  DRIVER_LOCATION_UPDATE: "driver:location:update",
  DRIVER_LOCATION_UPDATED: "driver:location:updated",
  TRAVEL_MESSAGE_CREATED: "travel-message:created",
  TRAVEL_MESSAGE_TYPING: "travel-message:typing",
};

let socket = null;

/** گرفتن اتصال socket (اگر وجود نداشت، ساخته می‌شود) */
export function getSocket() {
  const token = localStorage.getItem("token");
  if (!token) return null;

  if (socket && socket.connected) return socket;

  if (!socket) {
    socket = io(url, {
      transports: ["websocket", "polling"],
      auth: {
        token: `Bearer ${token}`,
        role: "driver",
      },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
    });
  } else if (!socket.connected) {
    // توکن ممکن است عوض شده باشد
    socket.auth = { token: `Bearer ${token}`, role: "driver" };
    socket.connect();
  }

  return socket;
}

/** عضویت در Room یک سفر برای دریافت رویدادهای لحظه‌ای آن */
export function joinTravelRoom(travelId) {
  const s = getSocket();
  if (!s || !travelId) return;
  s.emit(SOCKET_EVENTS.TRAVEL_JOIN, { travel_id: travelId });
}

/** خروج از Room سفر */
export function leaveTravelRoom(travelId) {
  const s = getSocket();
  if (!s || !travelId) return;
  s.emit(SOCKET_EVENTS.TRAVEL_LEAVE, { travel_id: travelId });
}

/**
 * ارسال موقعیت لحظه‌ای راننده (فقط وقتی سفر فعال دارد مجاز است)
 * مسافر این را روی نقشه می‌بیند.
 */
export function sendDriverLocation(travelId, latitude, longitude) {
  const s = getSocket();
  if (!s || !travelId) return;
  s.emit(SOCKET_EVENTS.DRIVER_LOCATION_UPDATE, {
    travel_id: travelId,
    latitude: String(latitude),
    longitude: String(longitude),
  });
}

/** قطع کامل اتصال (موقع خروج از حساب) */
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
